import gql from 'graphql-tag';

export namespace LightModeFields {

  export const fragment = gql`
    fragment lightModeFields on LightMode {
      ... on LightModeScene {
        id
      }
      ... on LightModeColor {
        r
        g
        b
        c
        w
      }
      ... on LightModeTemperature {
        temperature
      }
    }
  `;

  export type Definition =
    | {
      __typename: 'LightModeScene',
      id: number;
    }
    | {
      __typename: 'LightModeColor',
      r: number;
      g: number;
      b: number;
      c: number;
      w: number;
    }
    | {
      __typename: 'LightModeTemperature',
      temperature: number;
    };

}

export default gql`
  fragment lightModeFields on LightMode {
    ... on LightModeScene {
      id
    }
    ... on LightModeColor {
      r
      g
      b
      c
      w
    }
    ... on LightModeTemperature {
      temperature
    }
  }
`;
